/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

const requireEnv = (name: string) => {
  const envVariables = (window as any).env
  if (envVariables?.[name]) {
    return envVariables[name]
  }
  // eslint-disable-next-line no-console
  console.error(`could not get required environment variable ${name}`)
}

export const APP_ENVIRONMENT: string = requireEnv('APP_ENVIRONMENT') as string
export const BFF_BASE_URL: string = requireEnv('BFF_BASE_URL') as string

export const AUTH_REDIRECT_URI: string = requireEnv('AUTH_REDIRECT_URI') as string
export const FALL_BACK_URI: string = requireEnv('FALL_BACK_URI') as string
export const AUTH_CLIENT_ID: string = requireEnv('AUTH_CLIENT_ID') as string
export const AUTH_ROOT: string = requireEnv('AUTH_ROOT') as string
export const AUTH_SCOPE: string = requireEnv('AUTH_SCOPE') as string
export const AUTH_PKCE_LOGIN_URL: string = requireEnv('AUTH_PKCE_LOGIN_URL') as string
export const AUTH_PING_ID_TOKEN_REVOKE: string = requireEnv('AUTH_PING_ID_TOKEN_REVOKE') as string
export const AUTH_IGNITION_TOKEN_REVOKE: string = requireEnv('AUTH_IGNITION_TOKEN_REVOKE') as string
export const AUTH_IDLE_TIMEOUT_MINUTES: number = requireEnv('AUTH_IDLE_TIMEOUT_MINUTES')
export const AUTH_DISABLE_IN_DEV: boolean = !!requireEnv('AUTH_DISABLE_IN_DEV')
